module.exports = __webpack_public_path__ + "media/newstyle/images/services-footer-4-01850afd8ea7a601d6819a16dd1e4283.png";